export var TABS_APPEARANCES = Object.freeze({
  default: 'default',
  file: 'file'
});